import { useRequest } from '@byted/hooks';
import { Toast } from '@douyinfe/semi-ui';
import { forumPostService } from '@/api/forumPost';
import {
  SelfVisibleCommentRequest,
  SelfVisiblePostRequest,
  SelfVisibleReplyRequest,
  VisiblePostRequest,
} from '@/typings/open.platform.forum_bff/namespaces/forumpost';

const selfReply = async (req: SelfVisibleReplyRequest) => {
  const res = await forumPostService.selfVisibleReply(req);
  if (res.error) {
    throw new Error(res.message);
  }
  return res.data;
};
const selfComment = async (req: SelfVisibleCommentRequest) => {
  const res = await forumPostService.selfVisibleComment(req);
  if (res.error) {
    throw new Error(res.message);
  }
  return res.data;
};

const selfPost = async (req: SelfVisiblePostRequest) => {
  const res = await forumPostService.selfVisiblePost(req);
  if (res.error) {
    throw new Error(res.message);
  }
  return res.data;
};

export const usePostSelfVisible = () => {
  const { run } = useRequest(selfPost, {
    auto: false,
  });
  return {
    run,
  };
};

const nonSelfVisible = async (req: VisiblePostRequest) => {
  const res = await forumPostService.visiblePost(req);
  if (res.error) {
    throw new Error(res.message);
  }
  return res.data;
};

export const usePostNonSelfVisible = () => {
  const { run } = useRequest(nonSelfVisible, {
    auto: false,
  });
  return {
    run,
  };
};

export const useReplySelfVisible = () => {
  const { run } = useRequest(selfReply, {
    auto: false,
    onSuccess() {
      Toast.success('操作成功');
    },
  });
  return {
    run,
  };
};

export const useCommentSelfVisible = () => {
  const { run } = useRequest(selfComment, {
    auto: false,
    onSuccess() {
      Toast.success('操作成功');
    },
  });
  return {
    run,
  };
};
